/*
 
Skórki Material

 
*/

import * as M from '@material-ui/core';

//import './theme.css'

// https://in-your-saas.github.io/material-ui-theme-editor/
// http://mcg.mbitson.com/#!?mcgpalette0=%2338920a&mcgpalette2=%2326a69a&themename=rez1
// https://www.materialpalette.com/blue/lime

//https://material-ui.com/style/color/

// material

// po wpisaniu do pliku:
//import themeProject from './cfg/theme.json';

import { orange } from '@material-ui/core/colors';

const theme = M.createTheme({
  //  palette: appPalette,
  palette: {
    //   primary: { light: orange[50], main: "#c9823c", dark: "#e49a4d" },     
    //   secondary: { light: orange[50], main: "#c9823c", dark: "#e49a4d" },
    primary: { light: "rgba(191, 136, 85, 0.5)", main: "#bf8855" },
    secondary: { light: orange[50], main: "#bf8855" },
    error: { main: "rgb(244, 67, 54)" },
    text: { secondary: "#555" }
  },
  //palette : themeProject.palette,
  typography: {
    /*?? */
    //   useNextVariants: true, 
  },
  overrides: {
    MuiButton: {
      root:{
        textTransform: "none" as "none"
      }
    },
    MuiTableCell: {
      root: {
        padding: "14px 5px 14px 16px"
      }
    },
    MuiOutlinedInput: {
      input: {
        padding: "8px 14px",
        textAlign: "center",
        fontWeight: "bold"
      },
      multiline: {
        padding: "0px"
      }
    },
    MuiSelect: {
      selectMenu: {
        fontWeight: 400
      }
    },
    MuiCheckbox: {
      root: {
        color: "#bf8855",
      }
    },
    MuiFormControl: {
      marginNormal: {
        marginBottom: "10px"
      }
    },
    MuiIconButton: {
      root: {
          padding: "0px",
          color: "#bf8855"
      }
  },
  },
}
)

/*
const styleAppBar = (theme : any) => ({
  root: {
    width: '100%',
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  }
})  
  
styleAppBar,
*/

/*const styles = createStyles(appPalette);

export { styles,  appPalette }
*/
export default theme
